import React from "react";
import styled from "styled-components";
import usePaperMaterialData from "hooks/api/job/paperMaterial/usePaperMaterialData";
import { TSearchSelect } from "components/form/Field/TSearchSelect";
import { CustomPlainDivider } from "../HotStampingRadio";
import { PlusOutlined } from "@ant-design/icons";
import { CustomLinkButton } from "../HotStampingRadio";
import TSimpleRadio from "../../../../form/Field/TSimpleRadio";

const formatData = (resData) => {
  return resData?.map((d) => ({
    key: d.id,
    value: d.id,
    text: d.name,
  }));
};

const formatGrammage = (grammage) => {
  return grammage?.map((d) => `${d} GSM`);
};

function PaperMaterialSelect(props) {
  const {
    control,
    setValue,
    errors,
    trigger,
    watch,
    name,
    setPaperModalVisible,
    setAddPaperGrammageFrom,
  } = props;

  //State
  const {
    data: paperMaterialData,
    status: paperMaterialStatus,
  } = usePaperMaterialData();

  const selectedPaperGrammage = paperMaterialData?.find(
    (paper) => paper.id === parseInt(watch(`${name}.paper_material_id`))
  );

  return (
    <PaperMaterialContainer>
      <CustomPlainDivider orientation="left" plain>
        Paper
      </CustomPlainDivider>
      <TSearchSelect
        control={control}
        setValue={setValue}
        // defaultValue={watch(`${name}.paper_material.`)}
        name={`${name}.paper_material_id`}
        data={formatData(paperMaterialData)}
        placeholder="Select paper material"
        errors={errors}
        trigger={trigger}
      />
      {selectedPaperGrammage &&
        selectedPaperGrammage.grammage &&
        selectedPaperGrammage.grammage.length > 0 && (
          <>
            <TSimpleRadio
              options={formatGrammage(selectedPaperGrammage.grammage)}
              defaultValue={watch(`${name}.paper_grammage`)}
              control={control}
              name={`${name}.paper_grammage`}
              errors={errors}
              trigger={trigger}
              setValue={setValue}
              className="input"
              size="medium"
            />
          </>
        )}
      <CustomLinkButton
        onClick={() => {
          setPaperModalVisible(true);
          setAddPaperGrammageFrom(name);
        }}
        className="button"
        icon={<PlusOutlined />}
      >
        Add New Paper
      </CustomLinkButton>
    </PaperMaterialContainer>
  );
}

const PaperMaterialContainer = styled.div`
  display: flex;
  flex-direction: column;

  .input {
    margin-bottom: ${(props) => props.theme.spacing[2]};
  }
`;
export default PaperMaterialSelect;
